export default class StatsLog {
  static show_log: boolean = false;

  static init(show_log: boolean) {
    StatsLog.show_log = show_log;
  }

  static log(...args: any[]) {
    if (StatsLog.show_log) {
      console.log('#stats#', ...args);
    }
  }

  static error(...args: any[]) {
    if (StatsLog.show_log) console.error('#stats#', ...args);
  }
}
